package com.eladfinish.bible.contest.screens.search.usecases.specialSearch

import com.eladfinish.bible.contest.common.usecases.PartitionChapterUseCase
import com.eladfinish.bible.contest.common.usecases.RemoveTeamimUseCase
import com.eladfinish.bible.contest.extensions.removePrecedingOtPasuk
import com.eladfinish.bible.contest.screens.search.model.ChapterDetails
import com.eladfinish.bible.contest.utils.MyStringUtils.isFromSifreyEmet
import com.eladfinish.bible.contest.utils.RegexUtils
import com.eladfinish.bible.contest.utils.addGershaim
import com.eladfinish.bible.contest.utils.addGershaimAndColon
import com.eladfinish.bible.contest.utils.toOtiot
import org.koin.core.component.KoinComponent
import org.koin.core.component.inject

/**
 * Developed by
 * @author Elad Finish
 */

class IdenticalWordsReyshaLastAndSeyfaFirst(
    private val includeLog: Boolean = false,
    private val partitionChapterUseCase: PartitionChapterUseCase,
) : SpecialSearch,
    KoinComponent {

    private val sb = StringBuilder()

    private var counter = 0

    private val removeTeamimUseCase by inject<RemoveTeamimUseCase>()

    override fun process(chapterDetails: ChapterDetails) = with(chapterDetails) {
        val fromSifreyEmet = isFromSifreyEmet(chapterDetails.bookName)
        verses.forEachIndexed { index, verse ->
            val onlyContent = index.plus(1).toOtiot() + " " + RegexUtils.getOnlyContent(verse)
            val partition = partitionChapterUseCase(chapter = onlyContent, isFromSifreyEmet = fromSifreyEmet)
            if (partition.isEmpty()) {
                return@forEachIndexed
            }
            val partitioned = partition.first()
            val reyshaList = partitioned[1].filterNot { it.isBlank() }
            val seyfaList = partitioned[2].filterNot { it.isBlank() }
            val lastWordInReysha = reyshaList.last().removeTeamimExt()
            val firstWordInSeyfa = seyfaList.first().removeTeamimExt()

            if (lastWordInReysha == firstWordInSeyfa) {
                counter++
                sb.append("$counter) ")
                    .append(onlyContent.removePrecedingOtPasuk().addGershaimAndColon())
                    .append(" (${bookName} ${chapterName.addGershaim()}, ${index.plus(1).toOtiot().addGershaim()})")
                    .append("\n")
            }
        }
    }

    override fun getSummary(): String =
        sb.apply {
            if (includeLog) {
                append("\n@@@\n")
            }
        }.toString()

    private fun String.removeTeamimExt(): String =
        removeTeamimUseCase(this)

}
